<template>

  <div>
    <!--列表-->
    <Bank v-if="activeName == 'bank'"></Bank>
    <Cash v-if="activeName == 'cash'"></Cash>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Bank from './bank/list';
import Cash from './bank/cashlist';
export default {
  components: {
    Bank,
    Cash
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'bank',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'bank',
          value: '银行卡',
          path:'/plus/finance/bank/list'
        },
        {
          key: 'cash',
          value: '提现记录',
          path:'/plus/finance/bank/cashlist'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'regionagent'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'regionagent', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/finance/index.vue